import styled from "styled-components";

export const Container = styled.div`
    width: 40px;
    padding-top: 1px;
    line-height: 18px;
    float: left;

    @media(max-width: 450px) {
        /*left: -56px;*/
        background: var(--darkblue);
        width: 46px;
        border-radius: 0 15px 15px 0;
    }
    @media(max-width: 280px) {
        width: 33px;
    }
`;

export const Top = styled.div`
    padding-top: 4px;
    line-height: 18px;
    color: var(---darkblue);
    height: 53px;

    span{
        line-height: 10px;
        font-weight: 700;
        font-size: 10px;
        white-space: nowrap;
        display: block;
        text-transform: uppercase;
        -webkit-transform: rotate(270deg);
        -moz-transform: rotate(270deg);
        -ms-transform: rotate(270deg);
        -o-transform: rotate(270deg);
        transform: rotate(270deg);
        filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
        padding: 10px 0 10px 0;
        color: var(--darkblue);
    }

    @media(max-width: 450px) {
        color: rgba(255,255,255,0.8);
        span{
            color: rgba(255,255,255,0.8);
        }
    }
    @media(max-width: 1080px) {
      height: 50px;
    }
    @media(max-width: 280px) {
      height: 43px;
    }
`;
export const Dia = styled.div`
    display: flex;
    padding: 0;
    min-height: 50px;
    align-items: center;
    width: 100%;
    font-weight: 100;
    border-bottom: rgba(0,0,0,0.07) solid 1px;
    justify-content: center;
    font-weight: 400;
    font-family: 'Lilita One', Calibri, cursive;
    font-style: italic;
    color: var(--darkblue);
    font-size: 0.8rem;

    @media(max-width: 450px) {
        color: rgba(255,255,255,0.8);
        border-bottom: rgba(255,255,255,0.07) solid 1px;
    }
    
`